"use strict";
/*
 * if code is split into multiple bundles, sometimes each bundle
 * will get its own definition of this module and then instanceof checks
 * are unreliable, this provides a way to reliably check the error types
 *
 * eg this will always work:
 *   InvalidRequestError.matches(error);
 *
 * eg this might not work if you have code splitting:
 *   error instanceof InvalidRequestError
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionExpiredError = exports.NotFoundError = exports.UnauthorizedError = exports.InvalidRequestError = exports.isAppError = void 0;
const errorIsType = ({ TYPE }) => (e) => e instanceof Error
    && e.constructor.TYPE === TYPE;
/**
 * Returns true if the error is defined in this library
 */
const isAppError = (e) => e instanceof Error
    && typeof e.constructor.TYPE === 'string';
exports.isAppError = isAppError;
/**
 * Invalid request error
 *
 * `InvalidRequestError.matches(error)` is a reliable way to check if an error is an
 * `InvalidRequestError`; `instanceof` checks may not work if code is split into multiple bundles
 */
class InvalidRequestError extends Error {
    constructor(message) {
        super(message || InvalidRequestError.TYPE);
    }
}
exports.InvalidRequestError = InvalidRequestError;
InvalidRequestError.TYPE = 'InvalidRequestError';
InvalidRequestError.matches = errorIsType(InvalidRequestError);
/**
 * Unauthorized error
 *
 * `UnauthorizedError.matches(error)` is a reliable way to check if an error is an
 * `UnauthorizedError`; `instanceof` checks may not work if code is split into multiple bundles
 */
class UnauthorizedError extends Error {
    constructor(message) {
        super(message || UnauthorizedError.TYPE);
    }
}
exports.UnauthorizedError = UnauthorizedError;
UnauthorizedError.TYPE = 'UnauthorizedError';
UnauthorizedError.matches = errorIsType(UnauthorizedError);
/**
 * Not found error
 *
 * `NotFoundError.matches(error)` is a reliable way to check if an error is a
 * `NotFoundError`; `instanceof` checks may not work if code is split into multiple bundles
 */
class NotFoundError extends Error {
    constructor(message) {
        super(message || NotFoundError.TYPE);
    }
}
exports.NotFoundError = NotFoundError;
NotFoundError.TYPE = 'NotFoundError';
NotFoundError.matches = errorIsType(NotFoundError);
/**
 * Session expired error
 *
 * `SessionExpiredError.matches(error)` is a reliable way to check if an error is a
 * `SessionExpiredError`; `instanceof` checks may not work if code is split into multiple bundles
 */
class SessionExpiredError extends Error {
    constructor(message) {
        super(message || SessionExpiredError.TYPE);
    }
}
exports.SessionExpiredError = SessionExpiredError;
SessionExpiredError.TYPE = 'SessionExpiredError';
SessionExpiredError.matches = errorIsType(SessionExpiredError);
